// removed by extract-text-webpack-plugin
module.exports = {"radius":"ItemTagIndicator__radius__1uZBv","wrapper":"ItemTagIndicator__wrapper__gJD3F","center":"ItemTagIndicator__center__3mjSh","pulse":"ItemTagIndicator__pulse__3NdjW","echo":"ItemTagIndicator__echo__2SeDi"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/ItemTagIndicator.scss
// module id = 1043
// module chunks = 4 22 26 29